<albert-content-sidebar-list-view
  [itemSize]="itemSize"
  [service]="certificateHolderState"
  [(sidebarDrawerVisible)]="sidebarDrawerVisible"
>
  <ng-template #itemTemplate
               let-item
  >
    <div class="sidebar-list-row box-border overflow-hidden border-b border-gray-300"
         [attr.data-test]="'ch-item-' + item.uuid"
    >
      <albert-list-view-ch-list-item
        [item]="item"
        (itemClicked)="sidebarDrawerVisible.set(false)"
      />
    </div>
  </ng-template>
</albert-content-sidebar-list-view>
